const guiColors = {
    'motion-primary': '#FF80C4',
    'motion-primary-transparent': '#FF80C4e6',
    'motion-tertiary': '#DB61A2',

    'looks-secondary': '#FF80C4',
    'looks-secondary-light': '#ffc6df',
    'looks-secondary-lighter': '#ffe5f1',
    'looks-transparent': '#FF73B059',
    'looks-light-transparent': '#FF73B026',
    'looks-secondary-dark': '#BF4888',
    'looks-secondary-darker': '#7e2e5a',
    'looks-secondary-deep-dark': '#431a30',
	
	'data-primary': '#FF82EE',

    'extensions-primary': '#88D4F2',
    'extensions-tertiary': '#6C97D4',
    'extensions-transparent': '#74D3F235',
    'extensions-light': '#BAE2F2',

    'drop-highlight': '#FF94DA',

    'menu-bar-background-image': 'linear-gradient(to right, #91d3ff 0%, #ff91e2 100%)',
    'menu-bar-background-image-dark': 'linear-gradient(to right, #005091,#8A2770)'
};

const blockColors = {
    checkboxActiveBackground: '#FF80C4',
    checkboxActiveBorder: '#DB61A2'
};

export {
    guiColors,
    blockColors
};
